import * as Yup from 'yup';
import { REQUIRED_FIELD } from 'src/constants';

const dispatchRowSchema = Yup.object().shape({
  dispatchType: Yup.string()
    .oneOf(['Attempt', 'Response'])
    .required(REQUIRED_FIELD),
  fromUserId: Yup.number().required(REQUIRED_FIELD),
  technicianId: Yup.number().required(REQUIRED_FIELD),
  dateTime: Yup.date().required(REQUIRED_FIELD),
  dispatchTimezone: Yup.string().required(REQUIRED_FIELD),
  onShift: Yup.string().oneOf(['Yes', 'No']).required(REQUIRED_FIELD),
  contactMethod: Yup.string().required(REQUIRED_FIELD),
  outcome: Yup.string().required(REQUIRED_FIELD),
  reason: Yup.string().nullable(),
});

const validation = Yup.object({
  dispatches: Yup.array().of(dispatchRowSchema),
});

export default validation;
